import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueSweetAlert from 'vue-sweetalert2'
import VueFilterDateFormat from 'vue-filter-date-format'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css'

import App from './App.vue'
import router from './router'
import store from './store'


Vue.use(BootstrapVue)
Vue.use(VueSweetAlert)
Vue.use(VueFilterDateFormat)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
